import { useState, useContext } from 'react'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { ChevronRightIcon, ChevronUpDownIcon } from '@heroicons/react/20/solid'
import { UsersRound } from 'lucide-react'
import { ModalKey, ModalContext } from 'components/Modals/ModalContext'
import { ff, flags } from 'functions/roleBasedAccessUtils'

import OutlineButton from 'components/Buttons/OutlineButton'

export default function GroupListItem({ group, coaches }) {

    const navigate = useNavigate()

    const { ShowModal } = useContext(ModalContext)

    const userType = useSelector((state) => state.user.type)

    const canAssignGroupOwner = ff(flags.canAssignGroupOwner, { userType: userType })

    const [hideBackgroundHoverColor, setHideBackgroundHoverColor] = useState(false)

    const GetOwnerName = (ownerUserId) => {
        if (ownerUserId === null || ownerUserId === undefined) return 'No Owner'

        const coach = coaches ? coaches.find(coach => coach.id === ownerUserId) : null
        return coach ? `Owned By ${coach.firstName} ${coach.lastName.charAt(0).toUpperCase()}.` : 'No Owner'
    }

    const ShowGroupOwnerAssignmentModal = (e) => {

        e.stopPropagation()

        const modalData = {
            key: ModalKey.AssignGroupOwner,
            fullscreen: false,
            size: 'third',
            groupId: group.id,
            ownerUserId: group.ownerUserId,
            groupName: group.name,
        }

        ShowModal(modalData)

    }

    return (
        <li
            className={`
                w-full flex items-center px-6 py-4 gap-x-6 cursor-pointer
                ${hideBackgroundHoverColor ? '' : 'hover:bg-gray-50'}
            `}
            onClick={() => navigate(`/group/${group.id}`)}
        >
            <div>
                <div className="h-12 w-12 bg-orange-400 rounded-full flex items-center justify-center">
                    <UsersRound className="h-6 w-6 text-white mr-0.5" />
                </div>
            </div>

            <div className="flex-grow">
                <p className="font-lg font-semibold">{group.name}</p>

                {group.description.length > 0 && <p className="text-sm text-gray-600">{group.description}</p>}
                {group.description.length === 0 && <p className="text-sm text-gray-600">No Description</p>}
            </div>

            <div>
                <div className='w-52 relative'>
                    <p className='w-full h-10 flex items-center justify-center gap-x-2 rounded-2xl text-sm text-center text-sm text-gray-600'>
                        {group.groupAthleteCount === 0 &&
                            <>No Athletes</>
                        }

                        {group.groupAthleteCount > 0 &&
                            <>
                                {group.groupAthleteCount} Athlete{group.groupAthleteCount > 1 ? 's' : ''}
                            </>
                        }
                    </p>
                </div>
            </div>

            {canAssignGroupOwner && coaches && (
                <div>
                    <div
                        className='w-72 relative'
                        onMouseEnter={() => setHideBackgroundHoverColor(true)}
                        onMouseLeave={() => setHideBackgroundHoverColor(false)}
                    >
                        <OutlineButton
                            text={GetOwnerName(group.ownerUserId)}
                            className='hover:bg-gray-50'
                            action={(e) => ShowGroupOwnerAssignmentModal(e)}
                        />

                        <ChevronUpDownIcon
                            className="absolute top-2.5 right-3 text-gray-400 h-5 w-5"
                            onClick={(e) => ShowGroupOwnerAssignmentModal(e)}
                        />
                    </div>
                </div>
            )}

            <ChevronRightIcon className="text-gray-400 h-8" />
        </li>
    )
}
